module.exports = __webpack_public_path__ + "static/media/horror-film-fest.ee7d4a31.png";